import { useEffect, useRef, useState } from 'react'
import useOnScreen from '../app/hooks/useOnScreen'

export function useWaitTypewriter() {
  const ref = useRef<HTMLDivElement>(null)
  const isItemReacted = useOnScreen(ref as any)
  const [itemHasAppeared, setItemHasAppeared] = useState(false)
  useEffect(() => {
    // Make itemHasAppeared true when the item is visible, and never set it back to false
    if (isItemReacted) {
      setItemHasAppeared(true)
    }
  }, [isItemReacted])

  return {
    itemHasAppeared,
    ref
  }
}
